

import React, { useState } from 'react';
import {
  Box,
  Typography,
   MenuItem,
  FormControl,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

const promotionCategory = ['August','Christmas', 'Early Bird'];
const condition = ['Unique Traveller', 'Retargeting', 'Volume'];

const PromotionSetup = () => {
  const [selectedCategory, setSelectedCategory] = useState('');

  const handleCategoryChange = (event: SelectChangeEvent) => {
    setSelectedCategory(event.target.value);
  };

  const [selectedCondition, setSelectedCondition] = useState('');

  const handleConditionChange = (event: SelectChangeEvent) => {
    setSelectedCondition(event.target.value);
  };

 
  const [fromDate, setFromDate] = useState<dayjs.Dayjs | null>(null);
    const [toDate, setToDate] = useState<dayjs.Dayjs | null>(null);
  
    const [fromOpen, setFromOpen] = useState(false);
    const [toOpen, setToOpen] = useState(false);
  
    const handleDateChange = (newValue: dayjs.Dayjs | null) => {
      setToDate(newValue);
      setToOpen(false); // Close the calendar after selecting a date
    };

  return (
    <>
      <Box className="headingBtnWrap">
        <Typography variant="h1">Promotion Setup</Typography>
    </Box>
     <Box className="feeInputFieldWrap horizontalWrap">
        <div className="form-control inputFieldWrap">
            <label>Promotion Name</label>
            <input type="text" className="inputField" />
        </div>
        <div className="form-control inputFieldWrap">
            <label>Promotion Category</label>
                <FormControl sx={{ minWidth: 270 }} className="commondropdownWrap">
                    <Select
                        className="commondropdown"
                        id="supplier-select"
                        value={selectedCategory}
                        onChange={handleCategoryChange}
                        displayEmpty
                        renderValue={(selected) => {
                        if (selected === '') {
                            return <span style={{ color: '#888' }}>Select Promotion Category</span>;
                        }
                        return selected;
                        }}
                        >
                            <MenuItem value="">
                    Select Promotion Category
                    </MenuItem>
                    {promotionCategory.map((type) => (
                        <MenuItem key={type} value={type}>
                        {type}
                        </MenuItem>
                    ))}
                    </Select>
                </FormControl>
        </div>
        <div className="form-control inputFieldWrap">
            <label>Condition</label>
                <FormControl sx={{ minWidth: 270 }} className="commondropdownWrap">
                    <Select
                        className="commondropdown"
                        id="supplier-select"
                        value={selectedCondition}
                        onChange={handleConditionChange}
                        displayEmpty
                        renderValue={(selected) => {
                        if (selected === '') {
                            return <span style={{ color: '#888' }}>Select Condition</span>;
                        }
                        return selected;
                        }}
                        >
                            <MenuItem value="">
                    Select Condition
                    </MenuItem>
                    {condition.map((type) => (
                        <MenuItem key={type} value={type}>
                        {type}
                        </MenuItem>
                    ))}
                    </Select>
                </FormControl>
        </div>
        <div className="form-control inputFieldWrap">
            <label>Budget</label>
            <input type="text" className="inputField" placeholder='Ex: 100000' />
        </div>
        <div className="form-control inputFieldWrap">
            <label>Air</label>
            <input type="text" className="inputField" placeholder='Ex: 10' />
        </div>
        <div className="form-control inputFieldWrap">
            <label>Hotel</label>
            <input type="text" className="inputField" placeholder='Ex: 15' />
        </div>
        <div className="form-control inputFieldWrap">
            <label>Air + Hotel</label>
            <input type="text" className="inputField" placeholder='Ex: 20' />
        </div>
     </Box>
     <Box className="modalForm" marginBottom={4}>
             <LocalizationProvider dateAdapter={AdapterDayjs}>
               <Box className="inputFieldWrap">
                 <label>From</label>
                 <div onClick={() => setFromOpen(true)}>
                 <DatePicker
                   open={fromOpen}
                   onOpen={() => setFromOpen(true)}
                   onClose={() => setFromOpen(false)}
                   value={fromDate}
                   onChange={(newValue) => setFromDate(newValue)}
                   slotProps={{ textField: { fullWidth: true } }}
                   className='datePickerWrap'
                 />
                 </div>
               </Box>
               <Box className="inputFieldWrap">
                 <label>To</label>
                 <div onClick={() => setToOpen(true)}>
                 <DatePicker
                   open={toOpen}
                   // onOpen={() => setToOpen(true)}
                   onClose={() => setToOpen(false)}
                   value={toDate}
                   onChange={handleDateChange}
                   slotProps={{ textField: { fullWidth: true } }}
                   className='datePickerWrap'
                 />
                 </div>
               </Box>
             </LocalizationProvider>
           </Box>
      
    </>
  );
};

export default PromotionSetup;

